import { Navigate } from 'react-router-dom';
import DashboardLayout from 'components/DashboardLayout';
import MainLayout from 'components/MainLayout';
import Account from 'pages/Account';

import DeliveryList from 'pages/DeliveryList';
import StockTransferList from 'pages/StockTransferList';
import Dashboard from 'pages/Dashboard';
import Login from 'pages/Login';
import NotFound from 'pages/NotFound';
import ProductList from 'pages/ProductList';
import Register from 'pages/Register';
import Settings from 'pages/Settings';
import NotificationKoalaPage from './pages/NotificationKoalaPage';
import InvoiceVarifyList from './pages/InvoiceVarifyList';
import InvoiceDetailPage from './pages/InvoiceDetailPage';
import AddNewExtraChargesPage from './pages/AddNewExtraChargesPage';
import DriverRegistration from './pages/DriverRegistration';
import RunnerImport from './pages/RunnerImport';
import DriverList from 'pages/DriverList';
import RunnerList from 'pages/RunnerList';


const routes = [
  {
    path: 'app',
    element: <DashboardLayout />,
    children: [
      { path: 'account', element: <Account /> },
      { path: 'delivery-list', element: <DeliveryList /> },
      { path: 'dashboard', element: <Dashboard /> },
      { path: 'products', element: <ProductList /> },
      { path: 'settings', element: <Settings /> },
      { path: 'notificationDetail/:id', element: <NotificationKoalaPage /> },
      { path: '*', element: <Navigate to="/404" /> },
      { path: 'stocktransfer', element: <StockTransferList /> },
      { path: 'invoicevarifylist', element: <InvoiceVarifyList /> },
      { path: 'invoicedetailpage', element: <InvoiceDetailPage /> },
      { path: 'addnewextracharges', element: <AddNewExtraChargesPage /> },
      { path: 'driver-registration', element: <DriverRegistration /> },
      { path: 'driver-list', element: <DriverList /> },
      { path: 'runner-import', element: <RunnerImport /> },
      { path: 'runner-list', element: <RunnerList /> },

    ]
  },
  {
    path: '/',
    element: <MainLayout />,
    children: [
      { path: 'login', element: <Login /> },
      { path: 'register', element: <Register /> },
      { path: '404', element: <NotFound /> },
      { path: '/', element: <Navigate to="/login" /> },
      { path: '*', element: <Navigate to="/404" /> }
    ]
  }
];

export default routes;
